import { Button } from "@/shared/components/ui/button";
import { MessageSquare } from "lucide-react";

export default function NoResponses({
  onCollectResponses,
}: {
  onCollectResponses: () => void;
}) {
  return (
    <>
      <div className="w-[36px] h-[36px] rounded-[8px] mb-[15px] bg-white border border-border flex items-center justify-center">
        <MessageSquare height={20} width={20} color="#09090B" />
      </div>
      <h3 className="text-base font-semibold mb-[4px]">
        Henüz yanıt toplanmadı
      </h3>
      <p className="text-[14px] font-600 text-muted-foreground">
        Davet göndererek tedarikçilerden madde madde yanıt isteyin.
      </p>

      <div className="mt-[15px]">
        <Button size="sm" onClick={onCollectResponses}>
          Yanıt topla
        </Button>
      </div>
    </>
  );
}
